import { LoadingOutlined } from '@ant-design/icons';
import { ErrorContainer } from 'containers/App/TCM/ClientsTable/style';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { connect } from 'react-redux';

import {
  Title,
  Count,
  Item,
  List,
  Wrapper,
  Separator,
} from 'components/tcm/Sidebars/style';
import { fetchStatuses as fetchOfferStatusesAction } from 'redux/tcmOffer/actions';
import { OfferStatus } from 'tcm/offer/data';

const getMenuDataFromStatuses = (statuses) => {
  const all = statuses.find((status) => status.name === 'ALL');
  const allData = all ? [
    {
      label: 'Все',
      count: all.count,
      link: '/tcm/client/list',
      code: all.name,
    },
  ] : [];

  const calling = statuses.find((status) => status.name === OfferStatus.Calling);
  const callingData = calling ? [
    {
      label: 'В работе',
      count: calling.count,
      link: `/tcm/client/list?filter=${calling.name}`,
      code: calling.name,
    },
  ] : [];

  const waitConfirm = statuses.find((status) => status.name === OfferStatus.WaitConfirm);
  const waitConfirmData = waitConfirm ? [
    {
      label: 'Ожидают подтверждения',
      count: waitConfirm.count,
      link: `/tcm/client/list?filter=${waitConfirm.name}`,
      code: waitConfirm.name,
    },
  ] : [];

  const revision = statuses.find((status) => status.name === OfferStatus.Revision);
  const revisionData = revision ? [
    {
      label: 'Доработка',
      count: revision.count,
      link: `/tcm/client/list?filter=${revision.name}`,
      code: revision.name,
    },
  ] : [];

  const confirmed = statuses.find((status) => status.name === OfferStatus.Confirmed);
  const confirmedData = confirmed ? [
    {
      label: 'Подтвержденные',
      count: confirmed.count,
      link: `/tcm/client/list?filter=${confirmed.name}`,
      code: confirmed.name,
    },
  ] : [];

  const agreeing = statuses.find((status) => status.name === OfferStatus.Agreeing);
  const agreeingData = agreeing ? [
    {
      label: 'Согласившиеся',
      count: agreeing.count,
      link: `/tcm/client/list?filter=${agreeing.name}`,
      code: agreeing.name,
    },
  ] : [];

  const refused = statuses.find((status) => status.name === OfferStatus.Refused);
  const refusedData = refused ? [
    {
      label: 'Отказавшиеся',
      count: refused.count,
      link: `/tcm/client/list?filter=${refused.name}`,
      code: refused.name,
    },
  ] : [];

  return [
    ...allData,
    ...callingData,
    ...waitConfirmData,
    ...revisionData,
    ...confirmedData,
    ...((agreeing || refused) ? [{ label: 'separator' }] : []),
    ...agreeingData,
    ...refusedData,
  ];
};

const NavItem = ({
  title,
  statusList,
}) => {
  const location = useLocation();
  const { filter = '' } = queryString.parse(location.search);
  const statuses = getMenuDataFromStatuses(statusList);
  const activeFilter = statuses.findIndex((status) => filter === status.code);
  const activeFilterId = activeFilter > -1 ? activeFilter : 0;

  return (
    <List>
      <Title>
        {title}
      </Title>
      {statuses?.map((item, i) => (item.label === 'separator' ? (
        <Separator key={item.label} />
      ) : (
        <dd key={item.label}>
          <Item to={item.link} active={i === activeFilterId}>
            {item.label}
            {' '}
            <Count>{item.count}</Count>
          </Item>
        </dd>
      )))}
    </List>
  );
};

const Clients = ({

  statuses,
  isLoading,
  isLoaded,
  error,
  setStatusIsLoaded,

  fetchStatuses,
}) => {
  useEffect(() => {
    fetchStatuses();
  }, [fetchStatuses]);

  useEffect(() => {
    if (setStatusIsLoaded) {
      fetchStatuses();
    }
  }, [fetchStatuses, setStatusIsLoaded]);

  return (
    <Wrapper>
      {isLoaded && (
        <NavItem title="Клиенты" statusList={statuses} />
      )}

      {
        isLoading && <LoadingOutlined />
      }

      {
        Boolean(error) && <ErrorContainer>error</ErrorContainer>
      }
    </Wrapper>
  );
};

export default connect(
  (state) => ({
    // campaign
    statuses: state.tcmOffer.statuses.list,
    isLoading: state.tcmOffer.statuses.isLoading,
    isLoaded: state.tcmOffer.statuses.isLoaded,
    error: state.tcmOffer.statuses.error,

    setStatusIsLoaded: state.tcmOffer.statusSet.isLoaded,
  }),
  {
    fetchStatuses: fetchOfferStatusesAction,
  },
)(Clients);
